import React, { createContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { IntelApiClient, MSVApi, ThreatProfileNotificationsApi, ThreatProfilesApi } from '../api'

export const MatiApiClientContext = createContext(null)

export const MatiApiClientProvider = ({
  children,
  origin,
  token,
  threatProfilesPathPrefix = 'v1',
  threatProfilesNotificationsPathPrefix = ''
}) => {
  const { maApiHost, msvHost, threatProfileNotificationApiHost, threatProfilesApiHost } = origin

  const intelApiClient = useMemo(() => {
    return new IntelApiClient({ origin: maApiHost, token })
  }, [token, maApiHost])

  const msvClient = useMemo(() => {
    if (!msvHost) {
      return null
    }
    return new MSVApi({ origin: msvHost, token })
  }, [token, msvHost])

  const threatProfileNotificationsClient = useMemo(() => {
    if (!threatProfileNotificationApiHost) {
      return null
    }
    return new ThreatProfileNotificationsApi({ origin: threatProfileNotificationApiHost, token, pathPrefix: threatProfilesNotificationsPathPrefix })
  }, [token, threatProfileNotificationApiHost, threatProfilesNotificationsPathPrefix])

  const threatProfilesClient = useMemo(() => {
    if (!threatProfilesApiHost) {
      return null
    }
    return new ThreatProfilesApi({ origin: threatProfilesApiHost, token, pathPrefix: threatProfilesPathPrefix })
  }, [token, threatProfilesApiHost, threatProfilesPathPrefix])

  return (
    <MatiApiClientContext.Provider value={{ intelApiClient, msvClient, threatProfileNotificationsClient, threatProfilesClient }}>
      {children}
    </MatiApiClientContext.Provider>
  )
}

MatiApiClientProvider.propTypes = {
  children: PropTypes.node,
  client: PropTypes.instanceOf(IntelApiClient),
  token: PropTypes.string,
  origin: PropTypes.string,
  options: PropTypes.object,
}
